/*
 * Where the stack of box layers stands in the scene.
 *
 * The first layer is always on top, at the pick plane (`objectPosition.y`) —
 * where the cups, the cup→box assignment and the box overlays live — and the
 * second layer stands directly beneath it. Working on the second layer does
 * not move anything: the first layer is hidden so the layer beneath is in
 * plain view and can be clicked. Working on the first layer shows both layers
 * solid — the second is hidden under it from above anyway, and completes the
 * stack in 3D. The pallet is pushed down by one box height per layer so the
 * whole stack rests on it.
 */
/*
 * Whether a layer is hidden: only the layers stacked ABOVE the one being
 * worked on, since those are what would cover it.
 */
export var isLayerHidden = function (layer, activeLayer) {
    return layer < activeLayer;
};
/*
 * Whether a layer's boxes are drawn grey: in the flat top view, the layers
 * beneath the one being worked on, which otherwise show through its gaps
 * looking just like its own boxes. The 3D view shows the stack as it is.
 */
export var isLayerGreyedOut = function (layer, activeLayer, isTopView) { return isTopView && layer > activeLayer; };
/* World Y of a layer's top face. */
export var layerTopWorldY = function (layer, boxHeight, pickPlaneY) { return pickPlaneY - layer * boxHeight; };
/* World Y of the pallet's top surface under `layerCount` stacked layers. */
export var palletTopWorldY = function (layerCount, boxHeight, pickPlaneY) { return pickPlaneY - layerCount * boxHeight; };
